module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-GRAYZEL-eng.2298f7e8.png";